import { CategoryHierarchy } from "@Interfaces/Api/category";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import React, { useEffect } from "react";
import Link from "next/link";
import { useRouter } from "next/router";

interface CategoryProps {
  category: CategoryHierarchy;
}

const Category = ({ category }: CategoryProps) => {
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <Box
      sx={{
        marginRight: { xs: "1rem", sm: "2.5rem" },
        cursor: "pointer",
        "& nav": {
          transition: "opacity 0.5s ease-in-out",
          // borderTop: "3px solid green",
          // opacity: 0,
          // zIndex: -1,
          display: "none",
        },
        "&:hover": {
          "& nav": {
            borderTop: "3px solid green",
            // opacity: 1,
            // zIndex: 1,
            display: "block",
          },
        },
      }}
    >
      {/* <Link href={`/collections/${category.slug}`}> */}
      <Link href={`/collections/${category.slug}`}>
        <Typography
          variant="caption"
          sx={{
            fontSize: { xs: "0.75rem", sm: "1rem" },
            marginBottom: "0.7rem",
            textAlign: "center",
            textTransform: { xs: "capitalize", sm: "uppercase" },
            display: { xs: "none", sm: "flex" },
          }}
        >
          {category.name}
        </Typography>
      </Link>
      {category.childCategories.length > 0 && (
        <List
          // disablePadding
          sx={{
            bgcolor: "background.paper",
            position: "absolute",
            // marginLeft: { xs: 0, sm: "-0.5rem" },
            // right: "50%",
            // transform: "translate(50%)",
            boxShadow: 1,
            display: {
              xs: "none",
              sm: "block",
            },
            maxWidth: 200,
            // minWidth: {
            //   sx: 100,
            //   md: 200,
            // },
          }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        // subheader={
        //   <ListSubheader component="div" id="nested-list-subheader">
        //     {category.name}
        //   </ListSubheader>
        // }
        >
          {category.childCategories.map((childCategory) => (
            <Link
              href={`/collections/${category.slug}/${childCategory.slug}`}
              key={childCategory._id}
            >
              <ListItemButton>
                <ListItemText
                  style={{ textTransform: "capitalize" }}
                  primary={childCategory.name}
                />
              </ListItemButton>
            </Link>
          ))}
        </List>
      )}
    </Box>
  );
};

export default Category;
